import { useTheme } from 'styled-components';

import * as S from './styles';

export enum HeaderStyle {
    BASE = 'BASE',
    WHITE = 'WHITE',
}

interface HeaderProps {
    children: React.ReactNode;
    level?: number;
    className?: string;
    type?: HeaderStyle;
    overridenSize?: string | null;
    overridenMobileSize?: string | null;
}

export const Header: React.FC<HeaderProps> = ({
    children,
    level = 1,
    className,
    type,
    overridenSize = null,
    overridenMobileSize = null,
}: HeaderProps) => {
    const theme = useTheme();

    const HeaderStyles = {
        [HeaderStyle.BASE]: {
            color: theme.primary,
        },
        [HeaderStyle.WHITE]: {
            color: theme.greyLight,
        },
    };

    const headerColor = type
        ? HeaderStyles[type]
        : HeaderStyles[HeaderStyle.BASE];

    let desktopSize: string = '';
    let mobileSize: string = '';

    if (overridenSize && overridenMobileSize) {
        desktopSize = overridenSize;
        mobileSize = overridenMobileSize;
    } else if (overridenSize) {
        desktopSize = overridenSize;
        mobileSize = overridenSize;
    } else {
        switch (level) {
            case 1:
                desktopSize = '3.25rem';
                mobileSize = '2.5rem';
                break;
            case 2:
                desktopSize = '2.25rem';
                mobileSize = '2rem';
                break;
            case 3:
                desktopSize = '1.5rem';
                mobileSize = '1.5rem';
                break;
            case 4:
                desktopSize = '1.25rem';
                mobileSize = '1.25rem';
                break;
            default:
                break;
        }
    }

    return (
        <S.Heading
            $as={`h${level}`}
            $desktopSize={desktopSize}
            $mobileSize={mobileSize}
            className={className}
            $headerColor={headerColor.color}
        >
            {children}
        </S.Heading>
    );
};
